import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import AppButton from '../atoms/AppButton';
import Reveal from '../atoms/Reveal';
import CheckList from '../molecules/CheckList';
import { cta, plano } from '../content/site';
import { trackEvent } from '../utils/analytics';
import useViewOnce from '../hooks/useViewOnce';

/** Um plano só, então esta seção não é um comparativo de colunas — é um preço
 *  e uma lista do que ele inclui, lado a lado num cartão só. Um grid de três
 *  cartões para anunciar UM valor teria sobrado dois terços vazios, ou pior,
 *  inventado degraus que o produto não tem só para preencher a seção. */
function Pricing() {
  const ref = useViewOnce('view_precos');

  return (
    <section className="section" id="planos" ref={ref}>
      <Container className="shell">
        <div className="section-head section-head--center">
          <span className="section-kicker">Plano</span>
          <h2 className="section-title">Um plano só, com tudo incluído</h2>
          <p className="section-lead">
            O pagamento do cliente cai direto na sua conta: o Pix é gerado a partir da sua
            própria chave, e o dinheiro não passa por nós em momento nenhum.
          </p>
        </div>

        <Row className="justify-content-center">
          <Col lg={9}>
            <Reveal as="div" className="pricing-card">
              <span className="pricing-card-ribbon">Cancele quando quiser</span>
              <div className="pricing-card-main">
                <div className="plan-price">
                  <span className="plan-price-value">R$ {plano.preco}</span>
                  <span className="plan-price-unit">{plano.unidade}</span>
                </div>
                <p className="pricing-card-note">{plano.notaPreco}</p>
                <p className="pricing-card-pitch">{plano.pitch}</p>
                <AppButton
                  href={cta.principal.href}
                  variant="primary"
                  className="w-100"
                  onClick={() => trackEvent('click_whatsapp', { posicao: 'planos' })}
                >
                  {plano.cta}
                </AppButton>
              </div>

              <div className="pricing-card-divider" aria-hidden="true" />

              <div className="pricing-card-features">
                <CheckList items={plano.itens} className="pricing-card-list" />
              </div>
            </Reveal>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Pricing;
